<template>
    <div class="group-game-container">
        <div class="loading-container" v-if="outrightsOfferLoading"><img src="../../../assets/img/loading.svg"></div>
        <div class="group-game" v-else>
            <div>
                <div class="ggame-heading lb-sport sportbordercolor-outrights outrights-ggame-heading">
                    <span class="ggame-heading-icon sport-icon lb-sport icon-outrights"></span>
                    <h2 class="ggame-heading-text">{{singleOutrightTournament.name}}</h2>
                </div>
                <div v-for="outright in singleOutrightTournament.outrights" :key="outright.outrightsOfferId" class="outrights-item">
                    <div v-for="(marketGroup, mgIndex) in [outright.markets]" :key="mgIndex">
                    <div v-if="marketGroup.length > 0" class="ggame-odds-heading">
                        <div class="ggame-odds-lheading">{{outright.name | formatSpecName}}
                        <span>&nbsp;({{outright.startDate | formatOutrightsTicketMatchDate}} -</span>
                        <span>&nbsp;{{outright.endDate | formatOutrightsTicketMatchDate}})</span></div>
                    </div>
                    <template v-for="(market, mIndex) in marketGroup" >
                        <div v-if="market.show" class="ggame-item"
                            :class="{'is-blocked': outright.status == 'block'}"
                            :key="mIndex"><!--  || globalEventBlock[sportState] -->
                            <div class="ggame-item-content">
                                <div class="ggame-item-text">
                                    <div class="ggame-item-left">
                                        <div class="ggame-inner-top">
                                            <div class="ggame-item-teams">
                                                <span class="first-team">
                                                    <template v-if="!market.specifiers">{{market.name | formatModifierName(null, market.specifiers)}}</template>
                                                    <template v-else> {{market.name | formatModifierName(null, market.specifiers)}}
                                                        <span v-if="market.specifiers.Round"> krug {{market.specifiers.Round}}</span>
                                                        <div v-if="market.specifiers.Competitor">{{market.specifiers.Competitor}}</div>
                                                        <div v-else>{{market.specifiers.player}}</div>
                                                    </template>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="ggame-inner-bottom">
                                            <span class="ggame-item-matchid">{{outright.code}}</span>
                                            <span class="ggame-item-date">{{marketGroup[0].betStop | formatTicketMatchDate}}</span>
                                            <span class="ggame-item-oddscount">+{{marketGroup.length}}</span>
                                        </div>
                                    </div>
                                </div>
                                 <div v-if="outright.shouldRemove" class="odds-container sport no-odds-container">
                                    <div class="no-odd-text">{{$t('NOODDSAVAILABLEATTHISMOMENT')}}</div>
                                </div>
                                <div v-else class="odds-container sport">
                                    <template v-if="!outright.noActiveOutcomes">
                                        <template v-for="outcome in market.outcomes">
                                            <SingleOutrightOutcome
                                            class="odd-value"
                                            v-if="outcome.tags === 'preselected' && (outcome.status == 'block' || outcome.status == 'active')"
                                            :outcome="outcome"
                                            :market="market"
                                            :outright="outright"
                                            :key="outcome.outcomeHash"
                                            :details="false" />
                                            <!-- delete this below after switching on em feed-->
                                             <SingleOutrightOutcome
                                            class="odd-value"
                                            v-else-if="market.outcomes[0].tags !== 'preselected' && (outcome.status == 'block' || outcome.status == 'active')"
                                            :outcome="outcome"
                                            :market="market"
                                            :outright="outright"
                                            :key="outcome.outcomeHash"
                                            :details="false" />
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="more-outrights-footer" @click="selectOutright({
                                outrightId: outright.outrightsOfferId,
                                eventType: type,
                                push: true
                                })">
                        <p>{{$t('OTHEROUTRIGHTS')}}</p>
                        <img src="../../../assets/img/arrow-right.svg">
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import SingleOutrightOutcome from './SingleOutrightOutcome.vue';

export default {
    name: 'OutrightsTournaments',
    props: ['singleOutrightTournament', 'type'],
    components: {
        SingleOutrightOutcome,
    },
    data()
    {
        return {
            eventType: null,
        };
    },
    methods:
    {
        ...mapActions([
            'selectOutrightOutcome',
            'selectOutright',
        ]),
        getServeClass(outright)
        {
            const me = this;

            let classOut = '';

            classOut = me.getSportIconClass(outright.outrightId);

            classOut += ` ${classOut.replace('sporticon-', '')}-serve`;

            return classOut;
        },
        getSportIconClass(outrightId)
        {
            const me = this;

            let sportIconName = 'noicon';

            if (me.sportMapping[outrightId] !== undefined)
            {
                sportIconName = me.sportMapping[outrightId];
            }

            return `sporticon-${sportIconName}`;
        },
        isOutcomeSelected(param)
        {
            const {
                outright,
                outcome,
            } = param;

            if (this.betslipItemsMapping[
                `outrights_${outright.outrightsOfferId}_${outcome.outcomeHash}`
            ] != null)
            {
                return true;
            }

            return false;
            /* const me = this;

            if (!me.ticket)
            {
                return false;
            }

            const {
                outright,
                market,
                outcome,
            } = param;

            if (outcome.value === '-')
            {
                return false;
            }

            for (const item of me.ticket.items)
            {
                if (item.type === 'outrights'
                && item.eventId === outright.outrightsOfferId
                && item.meta.marketId === market.outrightsMarketId
                && item.meta.outcomeId === outcome.outrightsOutcomeId
                && item.meta.outcomeHash === outcome.outcomeHash
                && item.meta.specHash === market.lineHash)
                {
                    return true;
                }
            }

            return false; */
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'outrightsOfferLoading',
            'getOutrights',
        ]),
        sportMapping()
        {
            // if it will be needed
            const me = this;
            let val = {};

            if (me.globals
            && me.globals.props
            && me.globals.props.sportMapping)
            {
                val = me.globals.props.sportMapping;
            }

            return val;
        },
    },
};
</script>
